import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";
import ConfirmDialog from "../components/ConfirmDialog";
import FallbackImage from "../components/FallbackImage";
import { getImageFullUrl, pageRoute } from "../utils/common";
import { useNavigate } from "react-router-dom";
import BannerDialog from "./BannerDialog";

const BannerList = () => {
  const [products, setProducts] = useState([]);

  const [loading, setLoading] = useState(false);

  // ✅ Confirm dialog state
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [selectData, setSelectData] = useState({});

  const [open, setOpen] = useState(false);

  // ✅ Show confirm dialog before delete
  const requestDelete = (data) => {
    setDeleteData(data);
    setConfirmOpen(true);
  };

  const navigate = useNavigate()

  const pageChange = (url) => {
    navigate(url)
  }

  // Fetch products
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get("/api/banner");

      setProducts(res?.data?.data || []);
    } catch (err) {
      toast.error("Failed to load banner");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // Toggle status
  const handleStatusChange = async (id, newStatus) => {
    try {
      await apiClient.put(`/api/banner/${id}`, { status: newStatus });
      toast.success("Status updated");
      fetchProducts();
    } catch {
      toast.error("Failed to update status");
    }
  };

  // Delete product
  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`/api/banner/${id}`);
      toast.success("Banner deleted");
      fetchProducts();
    } catch {
      toast.error("Failed to delete Banner");
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" gutterBottom>
          Banner List
        </Typography>
        <Button variant="outlined" onClick={() => {
          setSelectData({})
          setOpen(true)
        }}>
          Add Banner
        </Button>
      </Box>
    
      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Price </TableCell>
              <TableCell>Align Info </TableCell>
              <TableCell>Banner Title </TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {products.length > 0 ? (
              products.map((row) => (
                <TableRow key={row.id}>
                  <TableCell><FallbackImage
                    src={getImageFullUrl(row.images)}
                    style={{ maxHeight: '50px' }}
                  /></TableCell>
                  <TableCell>{row.price}</TableCell>
                  <TableCell>{row.alignInfo}</TableCell>
                  <TableCell>{row.bannerTitle}</TableCell>
                  <TableCell>
                    <Switch
                      checked={row.status === "active"}
                      onChange={(e) =>
                        handleStatusChange(
                          row.id,
                          e.target.checked ? "active" : "inactive"
                        )
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                   
                    <IconButton
                      color="secondary"
                      onClick={() => {
                        setSelectData(row)
                        setOpen(true)
                      }}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      // onClick={() => handleDelete(row.id)}
                      onClick={() => requestDelete(row)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  {loading ? "Loading..." : "No Banner found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmDialog
        open={confirmOpen}
        title={`Delete Banner`}
        content="Are you sure you want to delete this Banner?"
        onClose={() => setConfirmOpen(false)}
        onConfirm={() => {
          handleDelete(deleteData?.id)
          setConfirmOpen(false)
        }}
      />
      <BannerDialog open={open} onClose={() => setOpen(false)} onSaved={() => {
        setOpen(false)
        fetchProducts()
      }}
        editData={selectData}
      />
    </Paper>
  );
};

export default BannerList;
